import AppMain from '@/views/appMain';
import Login from '@/views/login';
import Error from '@/views/404';
import Register from '@/views/register';
import userAPI from '@/api/user';
import Vue from 'vue';
import Router from 'vue-router';
import deviceRouter from './device';
import engineeringRouter from './engineering';
import fileRouter from './file';
import authorityRouter from './authority';

Vue.use(Router);

const router = new Router({
  // 路由启动history模式
  mode: 'hash',
  // 路由选中 class 定义名为 act
  linkActiveClass: 'act',
  routes: [
    {
      path: '/',
      component: AppMain,
      beforeEnter: (to, from, next) => {
        // 这里可以用来做登录验证等, hasLogin是临时定义的做示范
        const hasLogin = router.app.$options.store.getters.getLoginInfo.success;
        if (hasLogin) {
          next();
        } else {
          next({ path: '/login' });
        }
      },
      // 默认跳到设备管理页面
      redirect: 'device',
      children: [
        deviceRouter,
        engineeringRouter,
        fileRouter,
        authorityRouter,
      ],
    },
    {
      name: 'login',
      // 自定义title，给页面设置title用
      meta: { title: '登录' },
      path: '/login',
      component: Login,
    },
    {
      name: 'register',
      meta: { title: '注册' },
      path: '/register',
      component: Register,
    },
    {
      path: '/404',
      component: Error,
    },
    {
      name: '404',
      meta: { title: '404' },
      path: '*',
      redirect: '/404',
    },
  ],
  // 路由切换时自动滚动至顶部
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    }
    return { x: 0, y: 0 };
  },
});

// 路由变化时修改页面title
router.beforeEach((to, from, next) => {
  userAPI.checkSession().then((res) => {
    if (res === false) {
      next({ path: '/login' });
    }
  })
    .catch(() => next({ path: '/login' }));
  const title = to.meta.title || '';
  document.title = `Magic Cloud | ${title}`;
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js